import React from 'react';
import { useTranslation } from '../T/index.ts';
/** Image primitive with required, translated alt text. */ export const Image = ({ image, ...rest })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("img", {
        ...rest,
        src: image.src,
        alt: t(image.alt)
    });
};
